import { useEffect, useRef } from 'react';
import { Modal } from '../../components/Modal';
import { BTN_DANGER, BTN_TONAL } from './ui';

export interface ConfirmRequest {
  title: string;
  /** Platte tekst; `{naam}` wordt vervangen door de vetgedrukte naam. */
  message: string;
  naam?: string;
  confirmText: string;
  onConfirm: () => void;
}

/** Vriendelijke bevestiging voor verwijderen. Annuleren heeft standaard de focus (veilige keuze). */
export function ConfirmDialog({ request, onClose }: { request: ConfirmRequest; onClose: () => void }) {
  const cancelRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    // Na eventuele focuslogica van <Modal> zelf
    const id = requestAnimationFrame(() => cancelRef.current?.focus());
    return () => cancelAnimationFrame(id);
  }, []);

  const parts = request.message.split('{naam}');

  return (
    <Modal title={request.title} onClose={onClose}>
      <p className="text-sm leading-relaxed text-slate-600 dark:text-slate-300">
        {parts.map((part, i) => (
          <span key={i}>
            {i > 0 && <strong className="font-bold text-slate-900 dark:text-slate-100">"{request.naam ?? ''}"</strong>}
            {part}
          </span>
        ))}
      </p>
      <div className="mt-6 flex flex-wrap justify-end gap-3">
        <button ref={cancelRef} type="button" autoFocus onClick={onClose} className={BTN_TONAL}>
          Annuleren
        </button>
        <button
          type="button"
          onClick={() => {
            onClose();
            request.onConfirm();
          }}
          className={BTN_DANGER}
        >
          {request.confirmText}
        </button>
      </div>
    </Modal>
  );
}
